import { apiGet, apiPost, apiPut, apiDelete } from '@/services/api/apiClient';
import {
  CreateServiceProductRequest,
  UpdateServiceProductRequest,
  ServiceProductListParams,
  ServiceProductResponse,
  ServiceProductListResponse,
} from '@/constants/types';
import { API_ENDPOINTS } from '@/constants/endpoints';

export const serviceProductService = {
  async getServiceProducts(params?: ServiceProductListParams): Promise<ServiceProductListResponse> {
    const searchParams = new URLSearchParams();

    if (params?.search) searchParams.append('search', params.search);
    if (params?.serviceType) searchParams.append('serviceType', params.serviceType);
    if (params?.businessId) searchParams.append('businessId', params.businessId);
    if (params?.promoted !== undefined) searchParams.append('promoted', params.promoted.toString());
    if (params?.minPrice !== undefined) searchParams.append('minPrice', params.minPrice.toString());
    if (params?.maxPrice !== undefined) searchParams.append('maxPrice', params.maxPrice.toString());
    if (params?.isActive !== undefined) searchParams.append('isActive', params.isActive.toString());
    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.limit) searchParams.append('limit', params.limit.toString());
    if (params?.sort) searchParams.append('sort', params.sort);

    const query = searchParams.toString();
    return await apiGet<ServiceProductListResponse>(
      `${API_ENDPOINTS.SERVICE_PRODUCTS.GET_ALL}${query ? `?${query}` : ''}`
    );
  },

  async getServiceProduct(id: string): Promise<ServiceProductResponse> {
    return await apiGet<ServiceProductResponse>(API_ENDPOINTS.SERVICE_PRODUCTS.GET_BY_ID(id));
  },

  async createServiceProduct(data: CreateServiceProductRequest): Promise<ServiceProductResponse> {
    return await apiPost<ServiceProductResponse>(API_ENDPOINTS.SERVICE_PRODUCTS.CREATE, data);
  },

  async updateServiceProduct(id: string, data: UpdateServiceProductRequest): Promise<ServiceProductResponse> {
    return await apiPut<ServiceProductResponse>(API_ENDPOINTS.SERVICE_PRODUCTS.UPDATE(id), data);
  },

  async deleteServiceProduct(id: string): Promise<{ success: boolean; message: string }> {
    return await apiDelete<{ success: boolean; message: string }>(API_ENDPOINTS.SERVICE_PRODUCTS.DELETE(id));
  },

  async reportServiceProduct(id: string, reason: string): Promise<{ success: boolean; message: string; data?: any }> {
    return await apiPost<{ success: boolean; message: string; data?: any }>(
      API_ENDPOINTS.SERVICE_PRODUCTS.REPORT(id),
      { reason }
    );
  },

  async getServiceProductReports(page = 1, limit = 10): Promise<any> {
    return await apiGet<any>(`${API_ENDPOINTS.SERVICE_PRODUCTS.REPORTS}?page=${page}&limit=${limit}`);
  },
};
